import type { IntakeFieldErrors, IntakeFieldName } from './intake-validation';

/** Visual order of the fields, used for the summary and for the first-error focus. */
const FIELD_ORDER: IntakeFieldName[] = [
  'givenName',
  'familyName',
  'email',
  'phoneCountryIso',
  'phone',
  'currentCountryCode',
];

/** Field messages in visual order, one per field. */
export function listIntakeErrors(errors: IntakeFieldErrors): string[] {
  return FIELD_ORDER.map(field => errors[field]).filter(
    (message): message is string => Boolean(message)
  );
}

const API_PATH_TO_FIELD: Record<string, IntakeFieldName> = {
  givenName: 'givenName',
  familyName: 'familyName',
  email: 'email',
  phone: 'phone',
  currentCountryCode: 'currentCountryCode',
};

const FIELD_MESSAGES: Record<keyof typeof API_PATH_TO_FIELD, string> = {
  givenName: 'Enter a valid first name',
  familyName: 'Enter a valid last name',
  email: 'Enter a valid email address',
  phone: 'Enter a valid phone number',
  currentCountryCode: 'Select a valid country',
};

/**
 * Map the zod issues the API returns in `details` (`path: ['data', 'email']`)
 * to field errors. Issues for unknown paths are ignored.
 */
export function mapApiDetailsToFieldErrors(
  details: unknown
): IntakeFieldErrors {
  const errors: IntakeFieldErrors = {};
  if (!Array.isArray(details)) return errors;
  for (const issue of details) {
    const path = (issue as { path?: unknown } | null)?.path;
    if (!Array.isArray(path) || path[0] !== 'data') continue;
    const field = API_PATH_TO_FIELD[String(path[1])];
    if (!field || errors[field]) continue;
    errors[field] = FIELD_MESSAGES[field];
  }
  return errors;
}
